type PackageCardSize = "small" | "large";

export type PackageCardProps = {
  title: string;
  description: string;
  image: string;
  details: string;
  icon: string;
  size: PackageCardSize;
};
export const PackageCard = (props: PackageCardProps) => {
  const cardStyle = {
    backgroundImage: `url(${props.image})`,
  };

  const contentStyle = {
    backgroundColor: "rgba(255, 255, 255, 0.8)", // Adjust the alpha value as needed
  };

  const sizeClass = props.size === "small" ? "col-xl-4 col-12" : "col-12";

  return (
    <div className={`package-card-container ${sizeClass}`}>
      <div className={`package-card `} style={cardStyle}>
        <div
          className={`package-card-content d-flex flex-column align-items-center justify-content-center text-center`}
          style={contentStyle}
        >
          <h3>{props.icon}</h3>
          <h3>{props.title}</h3>
          <p>{props.description}</p>
          <p className="fst-italic">{props.details}</p>
        </div>
      </div>
    </div>
  );
};
